<template>
  <v-progress-circular v-if="loading" indeterminate color="primary" />
  <img
    v-else-if="url && !displayAvatarName"
    class="avatar"
    :style="avatarStyle"
    style="object-fit: cover"
    :src="url"
    @error="displayAvatarName = true"
    @click="emitClick"
  />
  <div v-else class="avatar" :style="nameStyle" @click="emitClick">
    {{ displayName }}
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    url: { type: String, default: undefined },
    name: { type: String, default: "" },
    size: { type: String, default: undefined }
  },

  data() {
    return {
      displayAvatarName: false
    };
  },

  computed: {
    displayName() {
      const arr = this.name.split(" ");
      if (arr.length === 1) {
        const firstChar = arr[0][0];
        return typeof firstChar === "string" ? firstChar.toUpperCase() : "";
      } else if (arr.length > 1) {
        const first = arr.shift()[0].toUpperCase();
        // const last = arr.pop()[0].toUpperCase()
        // return first + last
        return first;
      } else {
        return "";
      }
    },

    color() {
      let code = 0;

      if (this.displayName.length === 1) {
        code = (this.displayName.charCodeAt(0) - 65) % 360;
      } else if (this.displayName.length > 1) {
        const num1 = this.displayName.charCodeAt(0) - 65 + "";
        const num2 = this.displayName.charCodeAt(1) - 65 + "";

        code = Number(num1 + num2) % 360;
      }

      if (isNaN(code)) code = 0;

      return `hsl(${code}, 80%, 30%)`;
    },

    nameStyle() {
      return Object.assign(
        {},
        {
          background: "#8c8c8c",
          color: "white",
          margin: "auto"
        },
        this.avatarStyle
      );
    },

    avatarStyle() {
      if (this.size !== undefined) {
        return {
          width: this.size,
          height: this.size,
          "line-height": this.size,
          "font-size": this.size,
          "text-align": "center"
        };
      } else {
        return {
          "text-align": "center"
        };
      }
    }
  },

  methods: {
    emitClick(ev) {
      this.$emit("click", ev);
    }
  }
};
</script>

<style scoped>
.avatar {
  border-radius: 50%;
  color: var(--text-color);
}

.avatar--loading {
  background: url(https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif)
    no-repeat center;
}
</style>
